<script setup lang="ts">
/**
 * Bas du récapitulatif quand le payeur choisit de payer en plusieurs fois
 * (billetterie, adhésion) : le total RÉEL de la commande (chaque paiement a
 * ses frais), ce qui est débité aujourd'hui, puis la suite — à la place du
 * « Total à payer » en une fois, qui était faux dans ce cas (Karim
 * 2026-10-24 : 55,08 € affiché pour 21,25 € + 2 × 17,17 €).
 */
import { suiteIdentique, totalDesParts, type PartDuPanier } from "~/utils/plusieursFois";

const props = defineProps<{ parts: PartDuPanier[] }>();
const { t } = useI18n();
const { formatCurrency } = useFormatLangue();

const suite = computed(() => {
  const s = suiteIdentique(props.parts);
  return s
    ? t("plusieursFois.choix.puisNFois", { n: s.nombre, montant: formatCurrency(s.montant) })
    : t("plusieursFois.choix.puisNPrelevements", { n: props.parts.length - 1 });
});
</script>

<template>
  <div class="space-y-1.5" data-testid="totaux-plusieurs-fois">
    <div class="flex items-center justify-between">
      <span class="text-sm text-[#717198]">{{ t("plusieursFois.choix.totalEnNFois", { n: parts.length }) }}</span>
      <span class="text-sm font-medium text-[#2d2e5c] dark:text-white">{{ formatCurrency(totalDesParts(parts)) }}</span>
    </div>
    <div class="flex items-center justify-between">
      <span class="text-base font-bold text-[#2d2e5c] dark:text-white">{{ t("plusieursFois.choix.aPayerAujourdhui") }}</span>
      <span class="text-lg font-bold text-[#2d2e5c] dark:text-white">{{ formatCurrency(parts[0]?.montant ?? 0) }}</span>
    </div>
    <p class="text-xs text-[#717198] text-right">{{ suite }}</p>
  </div>
</template>
